export const GENERATE_AI_SESSION_NOTE = 'GENERATE_AI_SESSION_NOTE';
export const GENERATE_AI_SESSION_NOTE_SUCCESS = 'GENERATE_AI_SESSION_NOTE_SUCCESS';
export const GENERATE_AI_SESSION_NOTE_FAIL = 'GENERATE_AI_SESSION_NOTE_FAIL';
export const RESET_AI_SESSION_NOTE = 'RESET_AI_SESSION_NOTE';

/** Streaming-side status updates dispatched by the AI streaming hook. */
export const AI_NOTE_STREAM_DONE = 'AI_NOTE_STREAM_DONE';
export const AI_NOTE_STREAM_ERROR = 'AI_NOTE_STREAM_ERROR';
